import { Typography } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import type { TermProps } from '../TAndCTerm';
import Term from '../TAndCTerm';

export interface SectionProps {
  readonly index: string;
  readonly title: MessageKey;
  readonly terms: Omit<TermProps, 'index'>[];
}

const Section = ({ index, title, terms }: SectionProps): JSX.Element => {
  const t = useTranslations();

  return (
    <>
      <Typography Element="h2" variant="body" className="relative my-4 pl-14">
        <span className="absolute left-0">{index}.</span>
        <strong className="block uppercase">{t(title)}</strong>
      </Typography>
      {terms.map((term, i) => (
        <Term
          {...term}
          index={`${index}.${i + 1}`}
          isDefinition={index === '10'}
          key={`term-${index}.${i + 1}`}
        />
      ))}
    </>
  );
};

export default Section;
